import * as React from "react";

export class Link extends React.Component<{ href: string, class: string }, {}> {

    render() {
        return (
            <a href={this.props.href || "javascript:void(0);"} className={this.props.class}>
                {this.props.children}
            </a>
        )
    }
}